<div class="h-ruler" #rulerRefH></div>
<div class="v-ruler" #rulerRefV></div>

<div class="guidelines horizontal" #guidelinesRefH>
  <div class="guideline adder horizontal" #adderRefH></div>
  @for (pos of guidelines['horizontal']; track pos; let i = $index) {
    <div
      [attr.data-index]="i"
      class="guideline horizontal"
        [ngStyle]="{
            'opacity': guidelineOpacity,
            'transform': 'translateY(' + pos * zoom + 'px)',
            'background': getBackgroundColorOfHline(i)
        }">
    </div>
  }
</div>

<div class="guidelines vertical" #guidelinesRefV>
  <div class="guideline adder vertical" #adderRefV></div>
  @for (pos of guidelines['vertical']; track pos; let i = $index) {
    <div
      [attr.data-index]="i"
      class="guideline vertical"
        [ngStyle]="{
            'opacity': guidelineOpacity,
            'transform': 'translateX(' + pos * zoom + 'px)',
            'background': getBackgroundColorOfVline(i)
        }">
    </div>
  }
</div>